// FINAL - Handle individual X clicks and Clear all button

document.addEventListener('DOMContentLoaded', function() {
  class CompleteSync {
    constructor() {
      this.cameraForm = document.querySelector('[data-camera-filter="true"]');
      this.cameraCheckboxes = document.querySelectorAll('.camera-checkbox');
      
      this.init();
    }

    init() {
      // When checkbox changes
      this.cameraCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          if (this.cameraForm) {
            this.cameraForm.requestSubmit();
          }
        });
      });

      // Watch for X button clicks and Clear all
      document.addEventListener('click', (e) => {
        const xButton = e.target.closest('a[is="facet-remove"]');
        
        if (xButton) {
          // Check if it's "Clear all" button
          if (xButton.classList.contains('facet-clear-all')) {
            console.log('CLEAR ALL clicked');
            setTimeout(() => {
              this.clearAllCheckboxes();
            }, 100);
          } else {
            // Individual X button
            const ariaLabel = xButton.getAttribute('aria-label');
            console.log('X clicked -', ariaLabel);
            
            const decodedLabel = this.decodeHTML(ariaLabel);
            const filterName = this.extractFilterName(decodedLabel);
            
            if (filterName) {
              const checkbox = this.findCheckbox(filterName);
              if (checkbox) {
                console.log('Unchecking:', filterName);
                checkbox.checked = false;
                this.updateStyle(checkbox);
              }
            }
          }
        }
      });

      // Initial sync
      this.syncAllCheckboxes();
    }

    clearAllCheckboxes() {
      console.log('Clearing all checkboxes');
      this.cameraCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
        this.updateStyle(checkbox);
      });
    }

    decodeHTML(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    extractFilterName(label) {
      const match = label.match(/Remove filter[^"]*"([^"]*)"/);
      return match && match[1] ? match[1] : null;
    }

    findCheckbox(filterName) {
      // Exact match
      let checkbox = Array.from(this.cameraCheckboxes).find(
        cb => cb.getAttribute('data-camera-value') === filterName
      );
      
      if (checkbox) return checkbox;

      // Flexible match (ignore count)
      const filterBase = filterName.replace(/\(\d+\)/, '').trim();
      
      checkbox = Array.from(this.cameraCheckboxes).find(
        cb => {
          const cbValue = cb.getAttribute('data-camera-value');
          const cbBase = cbValue.replace(/\(\d+\)/, '').trim();
          return cbBase === filterBase;
        }
      );

      return checkbox;
    }

    syncAllCheckboxes() {
      const params = new URLSearchParams(window.location.search);
      const activeFilters = [];
      
      for (let [key, value] of params.entries()) {
        if (key.includes('camera_series')) {
          activeFilters.push(decodeURIComponent(value));
        }
      }

      this.cameraCheckboxes.forEach(checkbox => {
        const filterValue = checkbox.getAttribute('data-camera-value');
        checkbox.checked = activeFilters.includes(filterValue);
        this.updateStyle(checkbox);
      });
    }

    updateStyle(checkbox) {
      const label = checkbox.closest('.camera-option');
      if (!label) return;

      if (checkbox.checked) {
        label.classList.add('bg-blue-100', 'border-blue-500', 'text-blue-900');
        label.classList.remove('bg-white', 'border-gray-300');
      } else {
        label.classList.remove('bg-blue-100', 'border-blue-500', 'text-blue-900');
        label.classList.add('bg-white', 'border-gray-300');
      }
    }
  }

  new CompleteSync();
});